import { IArke } from "@intreba/arke-api-client";

export enum VisitPictureType {
  Vehicle = 0,
  Person = 1,
  Document = 2,
  Other = 3,
}

export interface VisitPictureResponseV1 {
  visitPictureType: VisitPictureType;
  pictureId: string;
  visitId: string;
  imageUri: string;
}

export const fetchPicturesForVisit = async (
  arke: IArke,
  siteId: string,
  visitId: string
): Promise<VisitPictureResponseV1[]> => {
  const pictures = await arke.performGet<VisitPictureResponseV1[]>(
    `/v1/sites/${siteId}/visits/${visitId}/pictures`
  );
  return pictures;
};
